import { useQuery } from 'react-query'

import { API_ENDPOINTS } from 'config/api'
import axios from 'config/axios'

import { BlogApiReponse, BlogData, BlogsApiResponse } from './blogs.type'

export const fetchAllBlogs = async () => {
  const response = await axios.get(
    API_ENDPOINTS.ARTICLES + '?resource_type=blog'
  )
  const { data } = (await response.data) as BlogsApiResponse

  return data.attributes.data.map((blog) => ({
    ...blog
  }))
}

export const useAllBlogs = () => {
  return useQuery<BlogData[]>(['blogs'], fetchAllBlogs)
}

export const fetchBlog = async (slug: string) => {
  const response = await axios.get(
    `${API_ENDPOINTS.ARTICLES}/fetch_by_slug?slug=${slug}`
  )
  const { data } = response.data as BlogApiReponse
  return {
    id: data.id,
    ...data.attributes
  }
}

export const useBlog = (slug: string) => {
  return useQuery<BlogData | null>(['blog', { slug }], () => fetchBlog(slug), {
    enabled: !!slug
  })
}
